import React from 'react';

import { Link } from '@change/ds-core-ui/next';

export const ViewMore: React.FC = () => {
	return (
		<div className="text-center">
			<Link data-qa="legislative-bodies-view-more" href="" variant="secondary">
				View more
			</Link>
		</div>
	);
};
